import { render, staticRenderFns } from "./CookieNotice.vue?vue&type=template&id=61ef8c34"
import script from "./CookieNotice.vue?vue&type=script&lang=ts"
export * from "./CookieNotice.vue?vue&type=script&lang=ts"
import style0 from "./CookieNotice.vue?vue&type=style&index=0&id=61ef8c34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_css-loader@6.11.0_webpack@5.98._lpz7yfflcfbikbc3glhfyeagle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports